module.exports = "data:image/webp;base64,UklGRpABAABXRUJQVlA4WAoAAAAQAAAAKwAAKwAAQUxQSP8AAAABgFPbUp3tdpSYiALqdDGBh/Q4QAISsBADOEBBBFClSzXfAybD/I86Ihi5beOI9mw7tdndP6DPFnIR54jegos/aTJ3sgNbSCHN96ORTrpW0ooDAqk5YUkxftdUs6b71HTdqq7fLudeysxjTFUqAvswgcIwDEwRcugmwwWMPfBJkdmA5csyvZauk5i2vnMEnSLpFB+fO4X2505Yie3VV24jkmxOkFVO1spZB+Z7mGtmas7neXjji+tOTCsjAZE+CcBBQ4J1jfquNhCDynBqBz+X+FPo/N73/F/41hTVb2PS1DZNGVXRAqcnAQhaCr6JSsOOv2AFEWNMKFNz4a7J4QMAVlA4IGoAAABwBACdASosACwAPm02lUikIqGhI4kAgA2JZwDMkbRbbGAc//ZDgB0DwzD/wAD++yOaVCZ7J2KwGeRD7JluTT5cPySRN/8U1aTBKDoTverbi02AWJuOTqOlD0Jr+ZU4lzF0aelYWXEf0AAA"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/sport/im-default.webp
// module id = UIOC
// module chunks = 3